import { Base } from "ui/Scripts/source/framework/base";
import { EditItem, IEditItem } from "ui/Scripts/source/models/common/editItem";
import { IModifyUser, ModifyUser } from "ui/Scripts/source/models/user/modifyUser";
import { IRecordEditItemFurtherEducation } from "./recordEditItemFurtherEducation";
import { IRecordFurtherEducationGroupNode } from "ui/Scripts/source/models/recordFurtherEducationGroup/recordFurtherEducationGroupNode";
import { IRecordQualificationUserFurtherEducation, RecordQualificationUserFurtherEducation } from "ui/Scripts/source/models/recordUserQualification/recordQualificationUserFurtherEducation";
import { RecordListItemUserQualification } from "ui/Scripts/source/models/recordUserQualification/recordListItemUserQualification";

export interface IRecordEditItemQualification extends IEditItem {
    furtherEducationId: string;
    furtherEducationGroupId: string;
    modifyUser: IModifyUser;
    code: string;
    requiredQualificationCount: number;
    userFurtherEducations: IRecordQualificationUserFurtherEducation[];
    validUserFurtherEducations: IRecordQualificationUserFurtherEducation[];
    furtherEducations: IRecordQualificationUserFurtherEducation[];
    valid: boolean;
    validityEndDate: number;

    getTitle(): string;
    setCodeAndValidity(furtherEducationGroups: IRecordFurtherEducationGroupNode[], userFurtherEducations: IRecordEditItemFurtherEducation[]);
}

export class RecordEditItemQualification extends EditItem implements IRecordEditItemQualification {
    furtherEducationId: string;
    furtherEducationGroupId: string;
    modifyUser: ModifyUser;
    code: string;
    requiredQualificationCount: number;
    userFurtherEducations: RecordQualificationUserFurtherEducation[];
    validUserFurtherEducations: RecordQualificationUserFurtherEducation[];
    furtherEducations: RecordQualificationUserFurtherEducation[];
    valid: boolean;
    validityEndDate: number;

    constructor();
    constructor(obj: IRecordEditItemQualification);
    constructor(obj?: any) {
        super(obj);
        this.furtherEducationId = obj && obj.furtherEducationId || "";
        this.furtherEducationGroupId = obj && obj.furtherEducationGroupId || "";
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
        this.code = obj && obj.code || "";
        this.requiredQualificationCount = obj && obj.requiredQualificationCount || 0;
        this.userFurtherEducations = Base.getTypedArray(obj ? obj.userFurtherEducations : null, RecordQualificationUserFurtherEducation);
        this.validUserFurtherEducations = Base.getTypedArray(obj ? obj.validUserFurtherEducations : null, RecordQualificationUserFurtherEducation);
        this.furtherEducations = Base.getTypedArray(obj ? obj.furtherEducations : null, RecordQualificationUserFurtherEducation);
        this.valid = obj && obj.valid || false;
        this.validityEndDate = obj && obj.validityEndDate || null;
    }

    getTitle(): string {
        return this.code;
    }

    setCodeAndValidity(furtherEducationGroups: IRecordFurtherEducationGroupNode[], userFurtherEducations: IRecordEditItemFurtherEducation[]) {
        RecordListItemUserQualification.setCodeAndValidity(this, furtherEducationGroups, userFurtherEducations);
    }

    static setFurtherEducationCodes(qualifications: IRecordEditItemQualification[], furtherEducationGroups: IRecordFurtherEducationGroupNode[], userFurtherEducations: IRecordEditItemFurtherEducation[]) {
        for (const qualification of qualifications) {
            RecordListItemUserQualification.setCodeAndValidity(qualification, furtherEducationGroups, userFurtherEducations);
        }
    }
        
    static sortRecordEditItemFurtherEducations(items: IRecordEditItemQualification[], column: string, asc: boolean): IRecordEditItemQualification[] {
        if (!items && items.length < 2) return items;
        if (column === "validity") {
            return items.sort((a: IRecordEditItemQualification, b: IRecordEditItemQualification) => {
                if (!a || !b) return 0;
                const result = ((asc ? 1 : -1) * Base.numCompare((a.userFurtherEducations.length > 0 ? 10 : 0) + (a.valid ? 1 : 0), (b.userFurtherEducations.length ? 10 : 0) + (b.valid ? 1 : 0)));
                if (result !== 0) return result;
                return Base.strCompare(a.code, b.code);
            });
        } else if (column === "validityEndDate") {
            return items.sort((a: IRecordEditItemQualification, b: IRecordEditItemQualification) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.numCompare(a.validityEndDate, b.validityEndDate)); });
        } else {
            return items.sort((a: IRecordEditItemQualification, b: IRecordEditItemQualification) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.code, b.code)); });
        }
    }
}

export class RecordEditItemQualificationSave extends EditItem {
    furtherEducationId: string;
    furtherEducationGroupId: string;

    constructor();
    constructor(obj: IRecordEditItemQualification);
    constructor(obj?: any) {
        super(obj);
        this.furtherEducationId = obj && obj.furtherEducationId || "";
        this.furtherEducationGroupId = obj && obj.furtherEducationGroupId || "";
    }
}